/* eslint-disable import/order */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { IoMdArrowBack, IoIosArrowForward } from 'react-icons/io';

import { HOME_STATUS, formatTime } from '../utils';
import { useEvieHomeContext } from '../EvieHomeProvider';
import womanShape from 'assets/images/woman-shape.webp';
import leftLine from 'assets/images/left-line.webp';
import rightLine from 'assets/images/right-line.webp';

import SolidButton from 'components/SolidButton';

const SessionExerciseInfo = () => {
  const { t } = useTranslation();
  const { changeHomeStatus, selectedTask } = useEvieHomeContext();
  const { exercises = [] } = selectedTask || {};

  const equipments = [
    ...new Set(
      exercises.reduce((acc, curr) => {
        const { exercise: { equipments: equip = [] } = {} } = curr;
        return [...acc, ...equip];
      }, []),
    ),
  ].sort();

  return (
    <section className="session-info">
      <section className="session-info__topbar">
        <IoMdArrowBack onClick={() => changeHomeStatus(HOME_STATUS.IDLE)} />
      </section>
      <header className="session-info__header">
        <img src={leftLine} alt="UI line" className="session-info__header_uiline" />
        <img src={rightLine} alt="UI line" className="session-info__header_uiline right" />
        {/* <div className="session-info__header_bg" /> */}
        <img src={womanShape} alt="woman shape" style={{ width: 104, height: 104, zIndex: 2 }} />
        <div className="session-info__title">
          <h2>{t('evieApp.sessionInfo.title')}</h2>
          {equipments.length === 0 ? (
            <ul className="session-info__equipments">
              {equipments.map((equip) => (
                <li key={equip} className="session-info__equipments_equip">
                  {equip}
                </li>
              ))}
            </ul>
          ) : null}
        </div>
      </header>
      <ul className="session-info__exercises">
        {exercises.map((ex) => {
          const { exercise: { id = '', image = '', title = '', duration = '' } = {} } = ex;
          const exDuration = Number(duration);
          const isSeconds = exDuration < 60;

          return (
            <li key={id} className="session-info__exercises_ex">
              <div className="session-info__exercises_eximg">
                <img src={image} alt={title} loading="lazy" />
              </div>
              <div>
                <h3 className="session-info__exercises_title">{title}</h3>
                <span className="session-info__exercises_duration">
                  {formatTime(exDuration)}{' '}
                  {isSeconds ? t('evieApp.sessionInfo.duration.seconds') : t('evieApp.sessionInfo.duration.minutes')}
                </span>
              </div>
              <IoIosArrowForward size={24} />
            </li>
          );
        })}
      </ul>
      <div className="session-info__startbtn">
        <SolidButton className="evie-survey" onClick={() => changeHomeStatus(HOME_STATUS.EXERCISES)}>
          {t('evieApp.programInfo.startBtn')}
        </SolidButton>
      </div>
    </section>
  );
};

export default SessionExerciseInfo;
